import {gsap} from "gsap";
import AnimationHelper from "../../../libs/animation-helper";
import EmitEvent, {
    HT_RESIZE,
    OBSERVER_HEIGHT_CHANGED, PAGE_AFTER,
    PAGE_LEAVE,
    PAGE_LOADED
} from "../../../libs/emit-event";
import services from "../../../libs/services";
import {checkDeviceMobile} from "../../../libs/helper";

export class HeaderLogo {
    constructor({el, header}) {
        this.DOM = {el, header};
        this.DOM.viewPoint = document.querySelector('.js-pageContent');
        this.isHide = false;
        this.disTop = 0;
        this.ajaxRendered = this.ajaxRendered.bind(this);
        this.pageEnter = this.pageEnter.bind(this);
        this.getProp = this.getProp.bind(this);
        this.initElements();
        this.bindEvent();
    }

    initElements() {
        this.DOM.logoScrolling = document.querySelector('.js-logoScrolling');
        if (this.DOM.logoScrolling) {
            if (!checkDeviceMobile()) {
                this.DOM.el.classList.remove('is-show');
                this.DOM.logoScrollingClone = this.DOM.logoScrolling.cloneNode(true);
                this.DOM.logoScrollingClone.classList.add('container', 'logoScrolling__clone');

                this.DOM.bigLogo = this.DOM.logoScrolling.querySelector('img');
                this.DOM.bigLogoClone = this.DOM.logoScrollingClone.querySelector('img');
                document.body.append(this.DOM.logoScrollingClone);
                this.DOM.logoScrolling.style.opacity = 0;
            }

            this.animater = new AnimationHelper(
                {
                    el: this.DOM.logoScrolling,
                    overrideWinScrolling: this.winScrolling.bind(this)
                }
            )
        } else {
            this.DOM.el.classList.add('is-show');
        }
    }

    setPositionClone() {
        const disTop = this.prop.top + Math.abs(services.smooth_scrolling_instance);
        const disTopYTran = Math.max(disTop, this.prop.minTop);
        if (this.DOM.logoScrollingClone) {
            gsap.set(this.DOM.logoScrollingClone, {y: disTopYTran});
        }
    }

    winScrolling(instance) {
        if (this.prop && this.prop.top !== null) {

            const disTop = this.prop.top - Math.abs(instance);
            const disTopYTran = Math.max(disTop, this.prop.minTop);
            if (this.DOM.logoScrollingClone) {
                gsap.set(this.DOM.logoScrollingClone, {y: disTopYTran});
            }
            const isUP = this.disTop > disTop;

            if (isUP && disTop < this.prop.trigger) {
                if (!this.isHide) {
                    this.isHide = true;
                    if (!checkDeviceMobile()) {
                        gsap.killTweensOf([this.DOM.logoScrolling, this.DOM.logoScrollingClone, this.DOM.bigLogoClone]);
                        const {width, height} = this.DOM.el.children[0].getBoundingClientRect();
                        gsap.set(this.DOM.logoScrollingClone, {opacity: 1});
                        gsap.to(this.DOM.bigLogoClone, {
                            width,
                            height,
                            duration: .8,
                            ease: 'power3.out',
                            onComplete: () => {
                                if (this.isHide) {
                                    this.DOM.el.classList.add('is-show');
                                    gsap.set(this.DOM.bigLogoClone, {opacity: 0});
                                }
                            }
                        });
                    } else {
                        gsap.killTweensOf([this.DOM.logoScrolling, this.DOM.el]);
                        gsap.to(this.DOM.logoScrolling, {opacity: 0, ease: 'power3.out', duration: .3});
                        gsap.fromTo(this.DOM.el, {visibility: 'visible'}, {
                            opacity: 1,
                            ease: 'power3.out',
                            duration: .3
                        });
                    }
                }
            } else if (disTopYTran > this.prop.minTop) {
                if (this.isHide) {
                    this.isHide = false;
                    if (!checkDeviceMobile()) {
                        this.DOM.el.classList.remove('is-show');

                        const {height, width} = this.DOM.bigLogo.getBoundingClientRect();
                        gsap.killTweensOf([this.DOM.logoScrolling, this.DOM.logoScrollingClone]);

                        this.DOM.el.classList.remove('is-show');
                        gsap.fromTo(this.DOM.bigLogoClone, {opacity: 1}, {
                            width,
                            height,
                            duration: .8,
                            ease: 'power3.out'
                        });
                    } else {
                        gsap.killTweensOf([this.DOM.logoScrolling, this.DOM.el]);
                        gsap.to(this.DOM.logoScrolling, {opacity: 1, ease: 'power3.out', duration: .3});
                        gsap.to(this.DOM.el, {
                            opacity: 0, ease: 'power3.out', duration: .3, onComplete: () => {
                                this.DOM.el.style = {};
                            }
                        });
                    }
                }
            }

            this.disTop = disTop;
        }
    }

    getProp() {
        if (this.DOM.logoScrolling) {

            const scrollTop = Math.abs(services.smooth_scrolling_instance);
            const {top} = this.DOM.logoScrolling.getBoundingClientRect();
            const rectHeaderLogo = this.DOM.el.children[0].getBoundingClientRect();
            const rectHeader = this.DOM.header.getBoundingClientRect();

            this.prop = {
                top: top + scrollTop,
                trigger: (rectHeader.height + scrollTop - 1),
                minTop: rectHeaderLogo.top
            };

            if (this.DOM.bigLogoClone) {

                this.DOM.bigLogoClone.style.width = null;
                this.DOM.bigLogoClone.style.height = null;

                this.setPositionClone();

            }
        }
    }

    pageEnter() {
        if (this.DOM.logoScrolling) {
            this.disTop = 0;
            this.getProp();
            this.setPositionClone();
        }
    }

    removeEvent() {
        this.DOM.el.classList.remove('is-show');
        this.DOM.logoScrolling = null;
        this.animater && this.animater.removeEvent();
        this.DOM.logoScrollingClone && this.DOM.logoScrollingClone.remove();
    }

    ajaxRendered() {
        this.initElements();
    }

    bindEvent() {
        EmitEvent.on(PAGE_AFTER, this.ajaxRendered);
        EmitEvent.on(PAGE_LOADED, this.pageEnter);
        EmitEvent.on(HT_RESIZE, this.getProp);
        EmitEvent.on(OBSERVER_HEIGHT_CHANGED, this.getProp);
        EmitEvent.on(PAGE_LEAVE, this.removeEvent.bind(this));
    }
}